var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddslab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#FF9800"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_115_4786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7404 8.62337H8.62349V11.7402C8.62349 12.0831 8.34297 12.3636 8.00011 12.3636C7.65725 12.3636 7.37673 12.0831 7.37673 11.7402V8.62337H4.25985C3.91699 8.62337 3.63647 8.34285 3.63647 7.99999C3.63647 7.65713 3.91699 7.37661 4.25985 7.37661H7.37673V4.25973C7.37673 3.91687 7.65725 3.63635 8.00011 3.63635C8.34297 3.63635 8.62349 3.91687 8.62349 4.25973V7.37661H11.7404C12.0832 7.37661 12.3637 7.65713 12.3637 7.99999C12.3637 8.34285 12.0832 8.62337 11.7404 8.62337Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_4786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.6364,
    height: 11.6364,
    fill: "white",
    transform: "translate(2.18188 2.18176)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddslab);
export default __webpack_public_path__ + "static/media/addslab.e112eb321ffa7d59dedf43028a5f067f.svg";
export { ForwardRef as ReactComponent };